<template>
  <div class="pay">
    <!-- 路径不正确状态-->
    <transition name="fade">
      <div class="loading" v-if="loading">
        <van-loading />
      </div>
    </transition>

    <div class="box">
      <div class="top">
        <div class="name">
          {{ merchant_info.merchant_name }}({{ merchant_info.bosser }})
        </div>
        <div class="label">付款金额(元)：</div>

        <div class="input_boxitem">
          <div class="input_box" @click="pop_up">
            <div class="input_mark">￥</div>
            <div class="input_number">
              <span>{{ subData.pay_amount }} </span>
              <p class="cursor"></p>
            </div>
          </div>
        </div>

        <div class="tips">温馨提示：付款前请确认金额</div>
        <div class="remark_btn" @click="handleClickRemarks()">
          <span>{{ subData.note }}</span>
          {{ subData.note ? "修改" : "添加备注" }}
        </div>
      </div>

      <!-- 底部支付 
      <div class="bottom">
        <div class="bottomconcent1">
          <div class="bottomconcent1_1">
            总计:<span class="qian">￥{{ pay_amount || 0 }}</span>
          </div>
          <div class="bottomconcent1_2">已优惠{{ amount || 0 }}元</div>
        </div>

        <div class="bottomconcent2">
          <button class="zf" @click="payment">立即支付</button>
        </div>
      </div>-->
    </div>

    <!-- 支付弹窗 -->
    <van-popup
      :overlay="false"
      v-model="show"
      position="bottom"
      :style="{ height: '4.8rem' }"
      @click-overlay="popup"
    >
      <div class="key_box" v-if="subData.market_id==13 || subData.market_id==12 || subData.market_id==19 || subData.market_id==18">
        <KeyBoard
          ref="goodKeyBoard"
          @finish="handleChangeGoodFinish"
          :k_decimal="2"
          :k_finish_disabled="Number(subData.pay_amount) <= 0"
          k_finish_text="确定"
          @input="handleChangeGoodInput"
        ></KeyBoard>
      </div>
      <div class="key_box" v-else>
        <KeyBoard
          ref="goodKeyBoard"
          @finish="handleChangeGoodFinish_old"
          :k_decimal="2"
          :k_finish_disabled="Number(subData.pay_amount) <= 0"
          k_finish_text="确定"
          @input="handleChangeGoodInput"
        ></KeyBoard>
      </div>

    </van-popup>

    <!-- 备注弹窗 -->
    <transition name="fade">
      <div class="pop_remarks" v-show="showNote" @click="handleCancelRemarks()">
        <div class="remarks_box" @click.stop="">
          <div class="title">添加备注</div>
          <div class="input">
            <input
              type="text"
              v-model="note"
              placeholder="收款人可见，最多20个字"
              autofocus
              maxlength="20"
            />
          </div>
          <div class="btns">
            <span @click.stop="handleCancelRemarks()">取消</span>
            <span @click.stop="handleSubmitRemarks()">确定</span>
          </div>
        </div>
      </div>
    </transition>
    <!-- 手机号弹窗 -->
    <transition name="fade">
      <div class="pop_remarks" v-show="showTel" @click="handleCancelTel()">
        <div class="remarks_box" @click.stop="">
          <div class="title">请输入手机号码</div>
          <div class="input">
            <input
              type="text"
              v-model="tel"
              placeholder="请输入手机号码......"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              autofocus
              maxlength="11"
            />
          </div>
          <div class="btns">
            <span @click.stop="handleCancelTel()">取消</span>
            <span @click.stop="handleSubmitTel()">确定</span>
          </div>
        </div>
      </div>
    </transition>
    <!--支付弹框-->
    <van-popup 
      round
      v-model="pay_show"
      @close="pay_close"
      closeable
      position="bottom"
      class="heig"
    >
      <div class="pay_num">
        <div class="pay_num_1">实付金额</div>
        <van-badge
          :content="parseFloat(amount) > 0 ? `优惠` + amount + `元` : ''"
        >
          <div class="pay_num_2box">
            <div class="pay_num_2"><span>￥</span>{{ pay_amount || 0 }}</div>
            <span class="discounts"></span>
          </div>
        </van-badge>
      </div>
      <van-radio-group v-model="radio" @change="radioradio" v-if="channel_type == 2 ? true : false">
        <van-cell-group>
          <van-cell clickable @click="radio = '微信支付'">
            <template #title>
              <div class="wx_title">
                <img class="wx" src="./../assets/img/wx.png" />
                <div>微信支付</div>
              </div>
            </template>
            <template #right-icon>
              <van-radio name="微信支付" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <van-radio-group v-model="radio" @change="radioradio" v-if="channel_type == 1 ? true : false">
        <van-cell-group>
          <van-cell clickable @click="radio = '支付宝支付'">
            <template #title>
              <div class="wx_title">
                <img class="wx" src="./../assets/img/zfb.png" />
                <div>支付宝支付</div>
              </div>
            </template>
            <template #right-icon>
              <van-radio name="支付宝支付" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <van-radio-group v-model="radio" @change="radioradio">
        <van-cell-group>
          <van-cell clickable @click="radio = '数字人民币'">
            <template #title>
              <div class="wx_title">
                <img class="wx" src="./../assets/img/sb.jpg" />
                <div>工行数字人民币<br>如有对应活动数币红包，支付后可在“数字人民币”App查看红包抵扣情况。</div>
              </div>
            </template>
            <template #right-icon>
              <van-radio name="数字人民币" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <div class="pay_button">
        <button class="pay_but" @click="payment0">确定支付</button>
      </div>
    </van-popup>


  </div>
</template>

<script>
import KeyBoard from "@/components/KeyBoard";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
var cavalue = null;
import {
  pay_getMerchantInfo,
  getdiscountcouponlist,
  baseUri,
  getuniqid,
  getTelSb,
} from "@/api/pay";

export default {
  name: "pay",
  components: {
    KeyBoard,
  },
  data() {
    return {
      pay_show: false, //  支付弹框
      checked: true, //按钮开关开启
      payment_show: false, //支付方式
      radio: "微信支付", //选择支付方式
      uuidvalue: "", //获取到uuid
      // show: false, //是否显示弹框
      show: true, //是否显示弹框
      loading: true,
      // 备注相关
      showNote: false,
      showTel: false, //手机号相关
      tel: "", //手机号用于数字人民币
      note: "",
      baseUri: "",

      // 金额相关
      subData: {
        merchant_id: "",
        pay_amount: "",
        note: "",
        market_id: "",
        mid: "",
        amount: 0, //优惠多少元
        customer_id: "", //优惠券的ID
        title: "", //优惠卷的描述信息
        trade_no: "", //票证信息
        index: "", //
        booth_id: "", //获取的参数
      },

      amount: "", //优惠多少元
      pay_amount: 0, //优惠后多少元
      // 小键盘相关
      focus_key_board: "",
      merchant_info: "",
      listarr: "", //获取优惠券的所有信息
      isclick: 1, // 是否可以点击
      //isactivebj: true, //没有优惠券的时候
      action: "", //当前是哪一个浏览器
      channel_type:"2",//给后端判断当前是什么支付的
    };
  },

  created() {
    getuniqid().then((res) => {
      if (res.resultCode == 1) {
        var uuid = res.resultInfo.uuid;
        var iscookie = document.cookie;
        if (iscookie) {
          let decodedCookie = decodeURIComponent(iscookie);
          let decodedCookievalue = decodedCookie.split(";");
          for (const key in decodedCookievalue) {
            if (decodedCookievalue[key].includes("uuidvl")) {
              cavalue = decodedCookievalue[key].split("=");
            }
          }
          if (cavalue[0] == "uuidvl") {
            this.uuidvalue = cavalue[1];
          } else {
            document.cookie = `uuidvl=${uuid}; expires=Thu, 18 Dec 2122 12:00:00 GMT; path=/`;
            this.uuidvalue = uuid;
          }
        } else {
          document.cookie = `uuidvl=${uuid}; expires=Thu, 18 Dec 2122 12:00:00 GMT; path=/`;
          this.uuidvalue = uuid;
        }
      }
    });
    let urlaction = this.browserJudgment();
    if (urlaction == 1) {
      this.action = urlaction;
      this.channel_type = 2;
      this.radio="微信支付";
    } else if (urlaction == 2) {
      this.channel_type = 1;
      this.action = urlaction;
      this.radio="支付宝支付";
    } else if (urlaction == 3) {
      this.action = urlaction;
      this.channel_type = 3;
    }
    //对获取到的参数做操作
    if (this.$route.query.pay_amount) {
      this.subData = this.$route.query;
      this.amount = this.$route.query.amount;
      this.pay_amount = (this.$route.query.pay_amount - this.amount).toFixed(2);
    } else {
      this.subData.merchant_id = this.$route.query.merchant_id;
      this.subData.booth_id = this.$route.query.booth_id;
    }
    this.getMerchantInfo(this.subData.merchant_id, this.subData.booth_id);
  },
  mounted() {
    document.getElementsByClassName("pay")[0].style.height =
      document.body.clientHeight + "px";
    document.getElementsByClassName("pop_remarks")[0].style.height =
      document.body.clientHeight + "px";
  },
  methods: {
    //判读当前页面是什么跳转过来的
    browserJudgment() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("微信端");
        return "1";
      } else if (ua.match(/Alipay/i) == "alipay") {
        console.log("支付宝端");
        return "2";
      } else {
        console.log("其他浏览器");
        return "3";
      }
    },
    xz_payment() {
      this.payment_show = true;
      this.pay_show = false;
    },
    pay_close() {
      this.pay_show = false;
      //选择优惠券的时候可能重新定义了需要重置为0
      this.select_ticket_index = 0;
      this.select_merchant_ticket_index = 0;
    },
    //支付类型发生变动
    radioradio(e) {
      this.payment_show = false;
      this.radio = e;
      console.log("支付方式:", this.radio);
    },

    popup() {
      //当前是微信环境的时候
      if (this.action == 1) {
        if (this.subData.pay_amount > 0) {
          market_id: this.subData.market_id,
          /*//底部金额
          this.pay_amount = (
            this.subData.pay_amount - this.subData.amount
          ).toFixed(2);
          //获取优惠券的逻辑
          getdiscountcouponlist({
            is_mini: 0,
            market_id: this.subData.market_id,
            mid: this.subData.mid,
            money: this.subData.pay_amount,
            status: 0,
          }).then((res) => {
            // console.log("空")
            if (res.resultCode == 1) {
              this.listarr = res.resultInfo.list;
              if (res.resultInfo.totalCount == 0) {
                this.subData.title = "您暂无代金券可使用！";
                this.subData.amount = 0;
                this.amount = "";
              } else {
                if (res.resultInfo.list[0].enable == 0) {
                  //禁止点击
                  // this.isclick = 0;
                  this.subData.amount = 0;
                  this.amount = "";
                  this.subData.title = "您暂无代金券可使用！";
                } else if (res.resultInfo.list[0].enable == 1) {
                  // this.isclick = 1;
                  this.subData.amount = 0;
                  this.amount = "";
                  // this.subData.title = "全场通用";
                  this.subData.amount =
                    res.resultInfo.list[0].ticketInfo.amount;
                  this.subData.customer_id = res.resultInfo.list[0].customer_id;
                  this.subData.title = res.resultInfo.list[0].ticketInfo.title;
                  this.amount = res.resultInfo.list[0].ticketInfo.amount;
                  this.subData.trade_no = res.resultInfo.list[0].trade_no;
                  this.pay_amount = (
                    this.subData.pay_amount - this.subData.amount
                  ).toFixed(2); //算出金额
                }
              }
            }
          });*/
          this.show = false;
        } else {
          // console.log('没有触发空')
          this.subData.amount = 0;
          (this.amount = ""),
            getdiscountcouponlist({
              is_mini: 0,
              market_id: this.subData.market_id,
              mid: this.subData.mid,
              money: this.subData.pay_amount,
              status: 0,
              page: 1,
              pageSize: 200,
            }).then((res) => {
              if (res.resultCode == 1) {
                let numbervalue = res.resultInfo.totalCount;
                if (res.resultInfo.totalCount > 0) {
                  if (res.resultInfo.list[0].enable == 1) {
                    this.subData.title = `您有${numbervalue}代金券可使用！`;
                  } else if (res.resultInfo.list[0].enable == 0) {
                    this.subData.title = `有${numbervalue}张代金券`;
                  }
                } else {
                  this.subData.title = "您暂无代金券可使用！";
                }
              }
            });
        }
      } else {
        console.log("当前不是微信环境");
      }
    },
    //点击弹框
    pop_up() {
      this.show = true;
    },

    // 数据输入中（价格输入中）
    handleChangeGoodInput(val) {
      this.subData.pay_amount = val;
      this.pay_amount = val;
    },
    // 数据修改完成（点击确定）
    handleChangeGoodFinish() {
      try {
        //2022.4.17
        this.pay_show = true; //打开支付
        this.amount = 0;
        //当前环境为微信的时候
        if (this.action == 1) {
          this.getCustomerScoreInfo().then((res) => {
            this.cacaulteScore();
          });
        } else {
        }
        //2021/12/22后加
        this.baseUri = baseUri; //获取当前的url
        this.browserJudgment();
      } catch (e) {
        //alert(JSON.stringify(e));
        // console.log(e);
      }
    },
    // 数据修改完成（点击确定）
    handleChangeGoodFinish_old() {
      //当前环境为微信的时候
      if (this.action == 1) {
        //底部金额
        this.pay_amount = (
          this.subData.pay_amount - this.subData.amount
        ).toFixed(2);
        //获取优惠券的逻辑
        getdiscountcouponlist({
          is_mini: 0,
          market_id: this.subData.market_id,
          mid: this.subData.mid,
          money: this.subData.pay_amount,
          status: 0,
        }).then((res) => {
          if (res.resultCode == 1) {
            this.listarr = res.resultInfo.list;
            if (res.resultInfo.totalCount == 0) {
              this.subData.title = "您暂无代金券可使用！";
              this.subData.amount = 0;
              this.amount = "";
            } else {
              if (res.resultInfo.list[0].enable == 0) {
                //禁止点击
                // this.isclick = 0;
                this.subData.amount = 0;
                this.amount = "";
                this.subData.title = "您暂无代金券可使用！";
              } else if (res.resultInfo.list[0].enable == 1) {
                // this.isclick = 1;
                this.subData.amount = 0;
                this.amount = "";
                // this.subData.title = "全场通用";

                this.subData.amount = res.resultInfo.list[0].ticketInfo.amount;
                this.subData.customer_id = res.resultInfo.list[0].customer_id;
                this.subData.title = res.resultInfo.list[0].ticketInfo.title;
                this.amount = res.resultInfo.list[0].ticketInfo.amount;
                this.subData.trade_no = res.resultInfo.list[0].trade_no;
                this.pay_amount = (
                  this.subData.pay_amount - this.subData.amount
                ).toFixed(2); //算出金额
              }
            }
          }
        });

      } else {
        console.log("当前不是微信环境");
      }

      //2021/12/22后加
      this.baseUri = baseUri; //获取当前的url
      this.browserJudgment();
      if (
        this.subData.pay_amount <= 0 ||
        this.pay_amount <= 0 ||
        !this.subData.pay_amount ||
        !this.pay_amount
      ) {
        this.$toast.fail("请输入正确的支付金额");
        return false;
      }
      this.show = false;
      this.payment();//直接支付
    },

    //跳转逻辑
    isclickfliter() {
      if (this.subData.pay_amount >= 0) {
        this.$router.replace({
          path: "/couponslist",
          query: this.subData,
        });
      }
    },

    // 获取商户信息
    getMerchantInfo(merchant_id, booth_id) {
      pay_getMerchantInfo({
        merchant_id: merchant_id,
        booth_id: booth_id,
      }).then((res) => {
        this.merchant_info = res.resultInfo;
        this.loading = false;
        this.subData.market_id = res.resultInfo.market_id;
        this.subData.mid = res.resultInfo.mid;
        //获取对应的市场信息

        //  console.log(this.subData.market_id)
        //  console.log(this.subData.mid)

        if (this.action == 1) {
          if (
            (this.subData.pay_amount <= 0 && this.subData.index == "") ||
            this.subData.pay_amoun == ""
          ) {
            // console.log("我被触发了")
            getdiscountcouponlist({
              is_mini: 0,
              market_id: this.subData.market_id,
              mid: this.subData.mid,
              money: this.subData.pay_amount,
              status: 0,
              page: 1,
              pageSize: 200,
            }).then((res) => {
              if (res.resultCode == 1) {
                console.log("我被触发了");
                // console.log(res);
                // console.log(res.resultInfo.totalCount);
                let numbervalue = res.resultInfo.totalCount;

                if (res.resultInfo.totalCount > 0) {
                  if (res.resultInfo.list[0].enable == 1) {
                    this.subData.title = `您有${numbervalue}代金券可使用！`;
                  } else if (res.resultInfo.list[0].enable == 0) {
                    this.subData.title = `有${numbervalue}张代金券`;
                  }
                } else {
                  this.subData.title = "您暂无代金券可使用！";
                }
              }
            });
          }
        } else {
          console.log("当前不是微信环境");
        }
      });
    },

    //前往支付
    payment() {
      if (this.radio == "数字人民币") {
        this.handleClickTel(); //输入手机号
      } else {
        this.baseUri = baseUri; //获取当前的url
        this.browserJudgment();
        if (
          this.subData.pay_amount <= 0 ||
          this.pay_amount <= 0 ||
          !this.subData.pay_amount ||
          !this.pay_amount
        ) {
          this.$toast.fail("请输入正确的支付金额");
          return false;
        }
        var access_token = window.localStorage.getItem("access-token");
        let url = `${this.baseUri}pay/icbc?merchant_id=${this.subData.merchant_id}&channel_type=${this.channel_type}&booth_id=${this.subData.booth_id}&pay_amount=${this.subData.pay_amount}&note=${this.subData.note}&coupe_id=${this.subData.customer_id}&access_token=${access_token}&trade_no=${this.subData.trade_no}&mid=${this.subData.mid}&market_id=${this.subData.market_id}`;
        window.location.href = url;
      }
    },
    //前往支付
    payment0() {
      //console.log(this.radio);
      if (this.radio == "数字人民币") {
        this.handleClickTel(); //输入手机号
      } else {
        this.baseUri = baseUri; //获取当前的url
        this.browserJudgment(); //支付
        if (
          this.subData.pay_amount <= 0 ||
          this.pay_amount <= 0 ||
          !this.subData.pay_amount ||
          !this.pay_amount
        ) {
          this.$toast.fail("请输入正确的支付金额");
          return false;
        }
        var access_token = window.localStorage.getItem("access-token");
        this.$toast.loading("请求银行资源中...");
        let url = `${this.baseUri}/pay/icbc?merchant_id=${this.subData.merchant_id}&channel_type=${this.channel_type}&booth_id=${this.subData.booth_id}&pay_amount=${this.subData.pay_amount}&note=${this.subData.note}&coupe_id=${this.subData.customer_id}&access_token=${access_token}&trade_no=${this.subData.trade_no}&mid=${this.subData.mid}&market_id=${this.subData.market_id}&uuid=${this.uuidvalue}`;
        window.location.href = url;
      }
    },

    /**
     * 备注相关
     */
    // 点击了弹窗的显示
    handleClickRemarks() {
      this.note = this.subData.note || "";
      this.showNote = true;
    },
    // 点击了弹窗的确认按钮
    handleSubmitRemarks() {
      this.subData.note = this.note;
      this.showNote = false;
    },
    // 点击了弹窗的取消按钮
    handleCancelRemarks() {
      setTimeout(() => {
        this.note = "";
      }, 300);
      this.showNote = false;
    },
    /**
     * 手机号相关
     */
    // 点击了弹窗的显示
    handleClickTel() {
      this.tel = this.subData.tel || "";
      this.showTel = true;
    },
    // 点击了弹窗的确认按钮
    handleSubmitTel() {
      this.subData.tel = this.tel;
      if (this.tel == "") {
        console.log("手机号码不能为空！！！");
        this.$toast.fail("手机号码不能为空！");
        return false;
      }else if(this.tel.length!=11){
        this.$toast.fail("手机号码输入不正确！");
        return false;
      }
      this.showTel = false;
      //console.log(this.subData.tel);
      this.paySB(this.tel);
    },
    // 点击了弹窗的取消按钮
    handleCancelTel() {
      setTimeout(() => {
        this.tel = "";
      }, 300);
      this.showTel = false;
    },
    //数银支付
    paySB(str) {
      getTelSb({
        sign: "d473093fe34e4a01876be0ed7fafd899",
        telephone: this.tel,
        subMerchantId: this.subData.merchant_id,
        amount: this.subData.pay_amount,
      }).then((res) => {
        if (res.resultInfo.isSubMerchantOpen == 0) {
          this.$toast.fail("该商户未开通工行数字货币账户！",0, 10000);
          return false;
        }
        if (res.resultInfo.openId == null) {
          this.$toast.fail("工行数字货币账户未开通，请先开通工行数字货币账户再扫码支付！",0, 10000);
          return false;
        }
        
        console.log(res.resultInfo.openId);
        document.querySelector("body").innerHTML = res.resultInfo.formData; //把数据传给body
        document.forms[0].submit();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.zf {
  width: 3.5rem;
  height: 0.88rem;
  background: linear-gradient(90deg, #6dd572 0%, #58b85c 100%);
  border-radius: 0.16rem;
  outline: none;
  border: none;
  margin-right: 0.3rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.pay_class {
  width: 100vw;
  margin: top 0.8rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.pay_item {
  width: 0.08rem;
  height: 0.36rem;
  background: #58b85c;
  border-radius: 1px;
  // margin-left: 0.3rem;
}
.pay_item2 {
  margin-left: 0.1rem;
}
.pay_item3 {
  margin-left: 0.1rem;
}
.pay_class2 {
  margin-top: 0.6rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.bottomconcent1 {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: space-evenly;
  margin-left: 0.3rem;
}
.bottomconcent2 {
  flex: 1;
}
.bottomconcent1_1 {
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #4a4a4a;
  display: flex;
  align-items: center;
}
.qian {
  font-size: 0.4rem;
  font-family: OPPOSans-B, OPPOSans;
  font-weight: normal;
  color: #ff0000;
}
.bottomconcent1_2 {
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.key_box {
  width: 100%;
  height: 4.8rem;
}
.remark_btn {
  width: 100%;
  // text-align: center;
  text-align: right;
  display: inline-block;
  font-size: 0.28rem;
  color: #259c8a;
  line-height: 0.8rem;
  span {
    padding-right: 0.1rem;
  }
}
.pay {
  background-color: #9c5525;
  height: 100vh;
  width: 100vw;
  position: relative;
  font-size: 0.28rem;
  overflow: hidden;
  background-color: #ffffff;
  .loading {
    width: 100%;
    height: 100vh;
    position: fixed;
    background-color: #fff;
    left: 0;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  // 基础

  .box {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    .top {
      text-align: center;
      color: #333;
      font-weight: bold;
      padding: 0 0.3rem;
      // padding-top: 1.5rem;
      padding-top: 1rem;
      .name {
        font-size: 0.58rem;
        line-height: 0.7rem;
        margin-bottom: 0.3rem;
      }
      .label {
        font-size: 0.32rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #333;
        font-weight: bold;
        line-height: 0.5rem;
        // margin-bottom: 0.6rem;
        margin-bottom: 0.2rem;
      }
      .voucher {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .voucheritem {
        width: 6.8rem;
        height: 0.8rem;
        background: linear-gradient(
          135deg,
          #ffdfcb 0%,
          #ffece2 49%,
          #ffd6ba 100%
        );
        border-radius: 0.16rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.26rem;
      }
      .voucheritem1 {
        font-size: 0.28rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #865002;
        margin-left: 0.2rem;
      }
      .voucheritem2 {
        margin-right: 0.2rem;
        font-size: 0.28;
        font-family: OPPOSans-B, OPPOSans;
        font-weight: 500;
        color: #ff0000;
      }
      .input_boxitem {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .input_box {
        width: 6.9rem;
        height: 1.22rem;
        background: #f9f9f9;
        border-radius: 0.16rem;
        //margin-top: 0.2rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .input_mark {
          font-size: 0.58rem;
          margin-left: 0.2rem;
        }
        .input_number {
          font-size: 0.65rem;
          height: 0.8rem;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          position: relative;
          & > span {
            width: auto;
            margin-right: 0.05rem;
          }
          .cursor {
            display: inline-block;
            width: 0.03rem;
            height: 0.5rem;
            background-color: #31b158;
            // position: absolute;
            // left: 0rem;
            // top: 50%;
            // transform: translateY(-50%);
            animation: inputFocus 0.8s linear infinite;
            @keyframes inputFocus {
              0% {
                opacity: 1;
              }
              50% {
                opacity: 0;
              }
              100% {
                opacity: 1;
              }
            }
          }
        }
      }
      .tips {
        color: #999;
        font-size: 0.28rem;
        text-align: right;
        font-weight: normal;
      }
    }
    .bottom {
      width: 100vw;
      height: 1.28rem;
      justify-content: space-between;
      display: flex;
      align-items: center;
      background: #ffffff;
      position: fixed;
      right: 0;
      left: 0;
      bottom: 0;
      border: solid 1px #eeeeee;
      .pay_btn {
        width: 100%;
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.36rem;
        font-weight: bold;
        color: #fff;
        background: #259c8a;
        border-radius: 0.1rem;
      }
      .key_box {
        width: 100%;
        height: 4.8rem;
      }
    }
  }
  // 弹窗相关
  .pop_remarks {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3000;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 3rem;
    transition: 0.3s all;
    display: flex;
    align-items: center;
    justify-content: center;
    .remarks_box {
      width: 5.4rem;
      border-radius: 0.1rem;
      background-color: #fff;
      .title {
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        text-align: center;
        padding-top: 0.36rem;
        letter-spacing: 0.02rem;
      }
      .input {
        padding: 0.3rem;
        input {
          width: 100%;
          background-color: #f5f5f5;
          border-radius: 0.1rem;
          height: 0.8rem;
          line-height: 0.5rem;
          color: #333;
          border: none;
          outline: none;
          text-indent: 0.2rem;
          font-size: 0.28rem;
        }
      }
      .btns {
        font-size: 0.32rem;
        color: #259c8a;
        display: flex;
        align-items: center;
        border-top: 0.01rem solid #ccc;
        letter-spacing: 0.02rem;
        font-weight: bold;
        span {
          width: 50%;
          height: 0.8rem;
          line-height: 0.8rem;
          text-align: center;
          &:nth-child(1) {
            box-sizing: border-box;
            border-right: 0.01rem solid #ccc;
          }
        }
      }
    }
  }
}
/*微信提示 */
.tips {
  color: #999;
  font-size: 0.26rem;
  text-align: right;
  font-weight: normal;
  margin-top: 0.2rem;
}

//没优惠券的背景
// .activebj{
//   background: red;
//         }

@w: 0.0181rem;
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

//支付弹框
.heig {
  height: fit-content;
}
.heig2 {
  height: 280 * @w;
}
.pay_num {
  width: 100%;
  height: 80 * @w;
  margin-top: 40 * @w;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px #eeeeee solid;
  .pay_num_1 {
    font-size: 16 * @w;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .pay_num_2box {
    display: flex;
    justify-content: center;
    align-items: center;
    .pay_num_2 {
      font-size: 34 * @w;
      font-family: OPPOSans-B, OPPOSans;
      font-weight: 600;
      color: #4a4a4a;
      span {
        font-size: 28 * @w;
        font-weight: 500;
      }
    }
  }
}
.pay_button {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80 * @w;
  bottom: 0;
  .pay_but {
    width: 345 * @w;
    height: 44 * @w;
    background: linear-gradient(90deg, #6dd572 0%, #58b85c 100%);
    border-radius: 8 * @w;
    border: none;
    font-size: 16 * @w;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20 * @w;
  }
}
.colorstyle {
  color: #259c8a;
}
.order {
  font-size: 16 * @w;
  color: #969799;
  width: 100%;
  height: 80 * @w;
  margin-top: 40 * @w;
  height: 40 * @w;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  span {
    font-size: 16 * @w;
    font-weight: 500;
    color: rgb(13, 12, 12);
  }
}

.wx_title {
  width: 100%;
  display: flex;
  align-items: center;
  .wx {
    width: 30 * @w;
    margin-right: 20 * @w;
  }
}

.discounts {
  font-size: 12 * @w !important;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #ff0000;
}

/deep/.van-badge--fixed {
  position: absolute;
  top: 0;
  right: 0;
  -webkit-transform: translate(50%, -50%);
  transform: translate(95%, -50%);
  -webkit-transform-origin: 100%;
  transform-origin: 100%;
}

.custom_item {
  font-size: 16 * @w;
  font-weight: 400;
  color: #2e3033;
}
.custom-title {
  letter-spacing: 0.1em;
  font-size: 14 * @w !important;
  font-weight: 400;
  color: #9ea5b8 !important;
}
.custom-title2 {
  font-size: 16 * @w;
  font-weight: 400;
  color: #2e3033;
}

.style_red {
  color: #ff0000;
}
</style>